"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.sort");
var _marketingCampaign = require("@/api/marketingCampaign");
var _download = require("@/utils/download");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SuperPopup',
  data: function data() {
    return {
      tipText: '',
      statusBuff: {
        0: '未发放',
        1: '已发放',
        2: '发放失败'
      },
      dialogVisible: false,
      queryData: {
        phoneNo: '',
        memberId: '',
        page: 1,
        size: 10,
        sort: null
      },
      tableData: [{}],
      total: 0
    };
  },
  methods: {
    sortChange: function sortChange(val) {
      var obj = {
        null: null,
        ascending: 1,
        descending: 0
      };
      this.queryData.sort = obj[val.order];
      this.listRankDetail();
    },
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.nickName
        }
      });
    },
    onRecharge: function onRecharge() {
      (0, _download.selfDownload)("/portal/system/rank/downloadRankDetail?rankId=".concat(this.queryData.rankId, "&phoneNo=").concat(this.queryData.phoneNo, "&sort=").concat(this.queryData.sort === null ? '' : this.queryData.sort, "&memberId=").concat(this.queryData.memberId));
    },
    openDialog: function openDialog(val) {
      console.log(val);
      if (val.indexType === 0) {
        this.tipText = '发放红包数';
      } else if (val.indexType === 1) {
        this.tipText = '有效订单金额 ';
      } else if (val.indexType === 2) {
        this.tipText = '有效订购单佣金';
      } else if (val.indexType === 3) {
        this.tipText = '有效订单数';
      }
      this.rankId = val.rankId;
      this.listRankDetail();
      this.dialogVisible = true;
    },
    onInquireList: function onInquireList() {
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.listRankDetail();
    },
    onInitializeList: function onInitializeList() {
      this.queryData = {
        phoneNo: '',
        memberId: '',
        page: 1,
        size: 10,
        sort: null
      };
      this.listRankDetail();
    },
    listRankDetail: function () {
      var _listRankDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              this.queryData['rankId'] = this.rankId;
              _context.n = 1;
              return (0, _marketingCampaign.listRankDetailApi)(this.queryData);
            case 1:
              res = _context.v;
              if (res.data && res.data !== null) {
                this.tableData = res.data.data || [];
                this.total = res.data.total;
              } else {
                this.tableData = [];
                this.total = 0;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function listRankDetail() {
        return _listRankDetail.apply(this, arguments);
      }
      return listRankDetail;
    }(),
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.listRankDetail();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.listRankDetail();
    }
  }
};